(() => {
  function unmute(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    video.muted = false;
    video.defaultMuted = false;
    video.volume = 1;
    video.removeAttribute('muted');
  }

  function unmuteVideosIn(container) {
    if (!container) return;

    const videos = container.querySelectorAll('video');

    videos.forEach((video) => {
      unmute(video);

      // Savor may reset the muted state as playback begins,
      // so check it again immediately afterwards.
      setTimeout(() => unmute(video), 0);
      setTimeout(() => unmute(video), 50);
      setTimeout(() => unmute(video), 150);
      setTimeout(() => unmute(video), 400);
    });
  }

  /*
   * Capture the user's interaction BEFORE the Savor
   * video component processes the click.
   */
  document.addEventListener(
    'pointerdown',
    (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const videoArea =
        target.closest('video') ||
        target.closest('[class*="video"]') ||
        target.closest('deferred-media');

      if (!videoArea) return;

      const container =
        videoArea.closest('.shopify-section') ||
        videoArea.parentElement;

      unmuteVideosIn(container);
    },
    true
  );

  /*
   * Also catch the normal click event after Savor has
   * started or replaced the video element.
   */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const videoArea =
        target.closest('video') ||
        target.closest('[class*="video"]') ||
        target.closest('deferred-media');

      if (!videoArea) return;

      const container =
        videoArea.closest('.shopify-section') ||
        videoArea.parentElement;

      unmuteVideosIn(container);

      setTimeout(() => unmuteVideosIn(container), 100);
      setTimeout(() => unmuteVideosIn(container), 500);
    },
    true
  );

  /*
   * If a video begins playing for any other reason,
   * remove the muted state.
   */
  document.addEventListener(
    'play',
    (event) => {
      if (event.target instanceof HTMLVideoElement) {
        unmute(event.target);
        setTimeout(() => unmute(event.target), 100);
      }
    },
    true
  );

  /*
   * Savor may dynamically create the actual <video>
   * element after the poster is clicked.
   */
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node instanceof HTMLVideoElement) {
          unmute(node);
        }

        node.querySelectorAll?.('video').forEach(unmute);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();